module.exports = __webpack_public_path__ + "img/hat-cowboy-side.587e6cf8.svg";